import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import PropertyDetailsBuilderTabContent from "./PropertyDetailsBuilderTabContent";
import Tabs from "../Tabs/Tabs";
import ErrorHelper from "../Errors/ErrorHelper";
import DateHelper from "../DateHelper/DateHelper";

export default class PropertyDetailsBuilder extends React.Component {
  constructor(props) {
    super(props);
    var image_group_ids;
    this.props.property.image_group &&
    this.props.property.image_group.images &&
    this.props.property.image_group.images.length
      ? (image_group_ids = this.props.property.image_group.images.map(
          (image) => image.id
        ))
      : (image_group_ids = []);

    this.state = {
      name: this.props.property.name,
      pricing_table_enabled: this.props.property.pricing_table_enabled,
      pricing_table_size: this.props.property.pricing_table_size,
      account_id: this.props.account_id,
      app_domain: this.props.property.app_domain,
      universal_analytics_tracking_id:
        this.props.property.universal_analytics_tracking_id,
      address_1: this.props.property.address_1,
      address_2: this.props.property.address_2,
      city: this.props.property.city,
      state: this.props.property.state,
      country: this.props.property.country,
      postal_code: this.props.property.postal_code,
      licensee_address_1: this.props.property.licensee_address_1,
      licensee_address_2: this.props.property.licensee_address_2,
      licensee_city: this.props.property.licensee_city,
      licensee_state: this.props.property.licensee_state,
      licensee_country: this.props.property.licensee_country,
      licensee_postal_code: this.props.property.licensee_postal_code,
      image_group_ids: image_group_ids,
      image_group: this.props.property.image_group
        ? this.props.property.image_group
        : null,
      images_data_table_path: this.props.images_data_table_path,
      active_tab: "general",
      errors: this.props.errors || [],
      loading: false,
      link_color: this.props.property.link_color,
      button_background_color: this.props.property.button_background_color,
      button_font_color: this.props.property.button_font_color,
      main_telephone: this.props.property.main_telephone,
      tollfree_telephone: this.props.property.tollfree_telephone,
      mobile_telephone: this.props.property.mobile_telephone,
      fax_telephone: this.props.property.fax_telephone,
      tdd_telephone: this.props.property.tdd_telephone,
      enable_messaging: this.props.property.enable_messaging,
      enable_messaging_terms: this.props.property.enable_messaging_terms,
      twilio_number: this.props.property.twilio_number,
      twilio_account_sid: this.props.property.twilio_account_sid,
      twilio_auth_token: this.props.property.twilio_auth_token,
      twilio_messaging_service_sid: this.props.property.twilio_messaging_service_sid,
      website_url: this.props.property.website_url,
      website_name: this.props.property.website_name,
      legal_business_name: this.props.property.legal_business_name,
      business_type_options: this.props.property.business_type_options,
      business_type: this.props.property.business_type,
      business_registration_id_type_options: this.props.property.business_registration_id_type_options,
      business_registration_id_type: this.props.property.business_registration_id_type,
      business_registration_number: this.props.property.business_registration_number,
      business_regions_of_operation_options: this.props.property.business_regions_of_operation_options,
      business_regions_of_operation: this.props.property.business_regions_of_operation,
      auth_rep_job_position_options: this.props.property.auth_rep_job_position_options,
      auth_rep_job_position: this.props.property.auth_rep_job_position,
      auth_rep_country_code: this.props.property.auth_rep_country_code,
      auth_rep_business_title: this.props.property.auth_rep_business_title,
      wihp_active: this.props.property.wihp_active,
      wihp_id: this.props.property.wihp_id,
      email: this.props.property.email,
      default_from_address: this.props.property.default_from_address,
      default_from_name: this.props.property.default_from_name,
      payment_gateway: this.props.property.payment_gateway,
      menu_items: this.props.property.menu_items,
      remotelock_refresh_token: this.props.property.remotelock_refresh_token,
      remotelock_grace_period_in_minutes:
        this.props.property.remotelock_grace_period_in_minutes,
      ru_active: this.props.property.ru_active,
      ru_contact_first_name: this.props.property.ru_contact_first_name || "",
      ru_contact_last_name: this.props.property.ru_contact_last_name || "",
      ru_contact_email: this.props.property.ru_contact_email || "",
      ru_contact_phone: this.props.property.ru_contact_phone || "",
      rooms_as_ru_properties: this.props.property.rooms_as_ru_properties,
      review_url: this.props.property.review_url || "",
      review_when: this.props.property.review_when || 0,
      ru_contact_birthdate: this.props.property.ru_contact_birthdate
        ? DateHelper.parseDateFromBackend(
            this.props.property.ru_contact_birthdate,
            this.props.date_format
          )
        : "",
      primary_contact_first_name:
        this.props.property.primary_contact_first_name || "",
      primary_contact_last_name:
        this.props.property.primary_contact_last_name || "",
      primary_contact_email: this.props.property.primary_contact_email || "",
      primary_contact_phone_number:
        this.props.property.primary_contact_phone_number || "",
      ad_words_conversion_id: this.props.property.ad_words_conversion_id || "",
      ad_words_conversion_label:
        this.props.property.ad_words_conversion_label || "",
      //Reservation Setting Props
      date: this.props.date,
      date_formats: this.props.date_formats || [],
      time: this.props.time,
      time_formats: this.props.time_formats || [],
      id: this.props.reservation_setting
        ? this.props.reservation_setting.id
        : null,
      check_in_time: this.props.reservation_setting
        ? DateHelper.parseDate(this.props.reservation_setting.check_in_time)
        : null,
      check_out_time: this.props.reservation_setting
        ? DateHelper.parseDate(this.props.reservation_setting.check_out_time)
        : null,
      maximum_stay: this.props.reservation_setting
        ? this.props.reservation_setting.maximum_stay
        : null,
      date_format: this.props.reservation_setting
        ? this.props.reservation_setting.date_format
        : null,
      time_format: this.props.reservation_setting
        ? this.props.reservation_setting.time_format
        : null,
      booking_window_days: this.props.reservation_setting
        ? this.props.reservation_setting.booking_window_days
        : 365,
      auto_assign: this.props.reservation_setting
        ? this.props.reservation_setting.auto_assign
        : null,
      default_number_of_nights: this.props.reservation_setting
        ? this.props.reservation_setting.default_number_of_nights
        : 1,
      default_check_in_date: this.props.reservation_setting
        ? this.props.reservation_setting.default_check_in_date
        : null,
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeAccountId = this.onChangeAccountId.bind(this);
    this.onImageChange = this.onImageChange.bind(this);
    this.onChangeCheckIn = this.onChangeCheckIn.bind(this);
    this.onChangeCheckOut = this.onChangeCheckOut.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.onChangeTime = this.onChangeTime.bind(this);
    this.onChangeAutoAssign = this.onChangeAutoAssign.bind(this);
    this.onChangeEnableMessaging = this.onChangeEnableMessaging.bind(this);
    this.onChangeEnableMessagingTerms = this.onChangeEnableMessagingTerms.bind(this);
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangeOrder = this.onChangeOrder.bind(this);
    this.onChangeDefaultNumberOfNights = this.onChangeDefaultNumberOfNights.bind(this);
    this.onChangeDefaultCheckInDate = this.onChangeDefaultCheckInDate.bind(this);
    this.onChangeMenuItemStatus = this.onChangeMenuItemStatus.bind(this);
    this.onChangeMenuItemName = this.onChangeMenuItemName.bind(this);
    this.onConnectRemoteLock = this.onConnectRemoteLock.bind(this);
    this.onDisconnectRemoteLock = this.onDisconnectRemoteLock.bind(this);
  }

  componentDidMount() {
    if (this.props.superadmin) {
      parent.window.ignore_unsaved_changes = true;
    }
  }

  render() {
    
    var self = this;
    var buttons = [
      {
        name: I18n.t("cancel"),
        html_attributes: ['data-dismiss="modal"'],
      },
      {
        name: I18n.t("submit"),
        button_classes: ["primary"],
        onClick: function (e) {
          self.onSave();
          return false;
        },
      },
    ];
    
    return (
      <div className="property-details-builder">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <PropertyDetailsBuilderTabContent
            {...this.props}
            {...this.state}
            property={this.props.property}
            onChange={this.onChange}
            onChangeAccountId={this.onChangeAccountId}
            onImageChange={this.onImageChange}
            onChangeOrder={this.onChangeOrder}
            onChangeCheckIn={this.onChangeCheckIn}
            onChangeCheckOut={this.onChangeCheckOut}
            onChangeDate={this.onChangeDate}
            onChangeTime={this.onChangeTime}
            onChangeAutoAssign={this.onChangeAutoAssign}
            onChangeEnableMessaging={this.onChangeEnableMessaging}
            onChangeEnableMessagingTerms={this.onChangeEnableMessagingTerms}
            onChangeDefaultNumberOfNights={this.onChangeDefaultNumberOfNights}
            onChangeDefaultCheckInDate={this.onChangeDefaultCheckInDate}
            onChangeActiveTab={this.onChangeActiveTab}
            onChangeMenuItemStatus={this.onChangeMenuItemStatus}
            onChangeMenuItemName={this.onChangeMenuItemName}
            onGeoSelectAddress={this.onGeoSelectAddress}
            onConnectRemoteLock={this.onConnectRemoteLock}
            onDisconnectRemoteLock={this.onDisconnectRemoteLock}
            onFlipSwitch={this.onFlipSwitch}
          />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  tabs() {
    if (this.props.superadmin) {
      var tabs = [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: ErrorHelper.tabErrorCount(this.state.errors, [
            "name",
            "app_domain",
            "address_1",
            "city",
            "postal_code",
            "state",
            "main_telephone",
            "tollfree_telephone",
            "mobile_telephone",
            "fax_telephone",
            "tdd_telephone",
            "twilio_number",
            "website_url",
            "primary_contact_first_name",
            "primary_contact_last_name",
            "primary_contact_email",
            "primary_contact_phone_number",
            "default_from_address",
          ]),
        }
      ];

      if (this.props.property && this.props.property.id) {

        tabs.push({
          tabName: I18n.t("menu"),
          targetName: "menu",
          classes: this.state.active_tab === "menu" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        });

        tabs.push({
          tabName: I18n.t("pricing"),
          targetName: "pricing",
          classes: this.state.active_tab === "pricing" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        });

        tabs.push({
          tabName: I18n.t("external_apis"),
          targetName: "external_apis",
          classes: this.state.active_tab === "external_apis" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        });

        tabs.push({
          tabName: I18n.t("payment_gateway"),
          targetName: "payment_gateway",
          classes:
            this.state.active_tab === "payment_gateway" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        });

        tabs.push({
          tabName: I18n.t("ru_queue_logs"),
          targetName: "ru_queue_logs",
          classes: this.state.active_tab === "ru_queue_logs" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        });

        tabs.push({
          tabName: I18n.t("imports"),
          targetName: "imports",
          classes: this.state.active_tab === "imports" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        });
      }

      tabs.push({
        tabName: I18n.t("text_messaging"),
        targetName: "text_messaging",
        classes: this.state.active_tab === "text_messaging" ? "active" : null,
        changeHandler: this.onChangeActiveTab,
      });

      tabs.push({
        tabName: I18n.t("internal_templates_tasks"),
        targetName: "internal_templates_tasks",
        classes: this.state.active_tab === "internal_templates_tasks" ? "active" : null,
        changeHandler: this.onChangeActiveTab,
      });

      tabs.push({
        tabName: I18n.t("account"),
        targetName: "account",
        classes: this.state.active_tab === "account" ? "active" : null,
        changeHandler: this.onChangeActiveTab,
      });

      return tabs;
    } else {
      const tabs = [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: ErrorHelper.tabErrorCount(this.state.errors, [
            "name",
            "app_domain",
            "address_1",
            "city",
            "state",
            "postal_code",
            "main_telephone",
            "tollfree_telephone",
            "mobile_telephone",
            "fax_telephone",
            "tdd_telephone",
            "twilio_number",
            "website_url",
            "primary_contact_first_name",
            "primary_contact_last_name",
            "primary_contact_email",
            "primary_contact_phone_number",
            "default_from_address",
          ]),
        },
        {
          tabName: I18n.t("reservation_settings"),
          targetName: "reservation_settings",
          classes:
            this.state.active_tab === "reservation_settings" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t("locks"),
          targetName: "locks",
          classes: this.state.active_tab === "locks" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: ErrorHelper.tabErrorCount(this.state.errors, [
            "remotelock_grace_period_in_minutes",
          ]),
        },
      ];

      if (this.props.property.ru_id) {
        tabs.push({
          tabName: I18n.t("channel_partners_account_details"),
          targetName: "partner_details",
          classes:
            this.state.active_tab === "partner_details" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: ErrorHelper.tabErrorCount(this.state.errors, [
            "ru_contact_first_name",
            "ru_contact_last_name",
            "ru_contact_phone",
            "ru_contact_email",
          ]),
        });
      }

      return tabs;
    }
  }

  /*
   * Change handlers
   */

  onGeoSelectAddress = (obj) => {
    this.setState(obj);
  };

  onSave() {
    var self = this;
    var property = this.prepParams();

    this.setState({ loading: true });

    $.ajax({
      type: this.props.new_record || this.props.superadmin ? "POST" : "PATCH",
      url: this.props.form_action,
      data: {
        property: property,
        property_id: property.id,
        old_property_id: self.props.old_property_id,
      },
    })
      .done((data) => {
        if (data && data.errors) {
          self.setState({ loading: false, errors: data.errors });
        } else {
          window.parent.$(window.parent).trigger("propertyDetailsSaved");

          this.setState({ loading: false });
          if (parent && parent.refresh_data) {
            parent.refresh_data(
              I18n.t("property_details_updated_successfully")
            );
          }

          if (parent && parent.hide_modal) {
            parent.hide_modal();
          }
          window.top.location.reload();
        }
      })
      .catch((data) => {
        if (data && data.responseJSON) {
          this.setState({ errors: data.responseJSON, loading: false });
          $(".modal-body").scrollTop(0);
        }
      });
  }

  onChangeActiveTab(active_tab) {
    this.setState({
      active_tab: active_tab,
    });
  }

  onChangeDefaultNumberOfNights(e) {
    this.setState({ default_number_of_nights: e.target.value });
  }

  onChangeDefaultCheckInDate(e) {
    this.setState({ default_check_in_date: e.target.value });
  }  

  onChange(e) {
    var { state } = this;
    state[e.target.name] = e.target.value;
    this.setState(state);
  }

  onFlipSwitch = (e) => {
    const state = { ...this.state };
    state[e.target.name] = e.target.checked;
    this.setState(state);
  };

  onChangeAccountId(e) {
    this.setState({ account_id: e.target.value });
  }

  onImageChange(image_group) {
    var image_group_ids = image_group.images.map((image) => image.id);
    if (image_group) {
      this.setState({
        image_group_ids: image_group_ids,
        image_group: image_group,
      });
    } else {
      this.setState({
        image_group_ids: null,
        image_group: null,
      });
    }
  }

  onConnectRemoteLock(remotelock_refresh_token) {
    this.setState({ remotelock_refresh_token: remotelock_refresh_token });
  }

  onDisconnectRemoteLock(remotelock_refresh_token) {
    this.setState({ remotelock_refresh_token: null });
  }

  onChangeOrder(idsInOrder) {
    this.setState({ image_group_ids: idsInOrder });
  }

  onChangeCheckIn(check_in_time) {
    this.setState({
      check_in_time: check_in_time,
    });
  }

  onChangeCheckOut(check_out_time) {
    this.setState({
      check_out_time: check_out_time,
    });
  }

  onChangeTime(e) {
    this.setState({
      time_format: e.target.value,
    });
  }
  onChangeDate(e) {
    this.setState({
      date_format: e.target.value,
    });
  }

  onChangeAutoAssign(auto_assign) {
    this.setState({
      auto_assign: auto_assign.target.checked,
    });
  }

  onChangeEnableMessaging(enable_messaging) {
    this.setState({
      enable_messaging: enable_messaging.target.checked,
    });
  }

  onChangeEnableMessagingTerms(enable_messaging_terms) {
    this.setState({
      enable_messaging_terms: enable_messaging_terms.target.checked,
    });
  }

  onChangeMenuItemStatus(event) {
    const { menu_items } = this.state;

    for (var i = 0, ilen = menu_items.length; i < ilen; i++) {
      const menu_item = menu_items[i];
      const update_children = false;
      if (menu_item && menu_item.id === event.target.name) {
        menu_item.status = event.target.checked ? "enabled" : "disabled";
        update_children = true;
      }
      if (menu_item.child_menu_items && menu_item.child_menu_items.length) {
        for (
          var j = 0, jlen = menu_item.child_menu_items.length;
          j < jlen;
          j++
        ) {
          const child_menu_item = menu_item.child_menu_items[j];
          if (
            update_children ||
            (child_menu_item && child_menu_item.id === event.target.name)
          ) {
            child_menu_item.status = event.target.checked
              ? "enabled"
              : "disabled";
          }
        }
      }
    }
    this.setState({ menu_items: menu_items });
  }

  onChangeMenuItemName(event) {
    const { menu_items } = this.state;

    for (var i = 0, ilen = menu_items.length; i < ilen; i++) {
      const menu_item = menu_items[i];
      if (menu_item && menu_item.id === event.target.name) {
        menu_item.name = event.target.value;
        break;
      }
      if (menu_item.child_menu_items && menu_item.child_menu_items.length) {
        for (
          var j = 0, jlen = menu_item.child_menu_items.length;
          j < jlen;
          j++
        ) {
          const child_menu_item = menu_item.child_menu_items[j];
          if (child_menu_item && child_menu_item.id === event.target.name) {
            child_menu_item.name = event.target.value;
            break;
          }
        }
      }
    }
    this.setState({ menu_items: menu_items });
  }

  /**
   * Helper functions
   */

  prepParams() {
   
    return {
      id: this.props.property ? this.props.property.id : null,
      name: this.state.name,
      app_domain: this.state.app_domain,
      universal_analytics_tracking_id:
        this.state.universal_analytics_tracking_id,
      address_1: this.state.address_1,
      address_2: this.state.address_2,
      city: this.state.city,
      state: this.state.state,
      country: this.state.country,
      postal_code: this.state.postal_code,
      licensee_address_1: this.state.licensee_address_1,
      licensee_address_2: this.state.licensee_address_2,
      licensee_city: this.state.licensee_city,
      licensee_state: this.state.licensee_state,
      licensee_country: this.state.licensee_country,
      licensee_postal_code: this.state.licensee_postal_code,
      remotelock_grace_period_in_minutes:
        this.state.remotelock_grace_period_in_minutes,
      file_upload_group_file_uploads:
        this.state.image_group && this.state.image_group.images
          ? this.state.image_group.images.map(function (image_upload) {
              return image_upload.id;
            })
          : null,
      image_group_ids: this.state.image_group_ids,
      logo_image_id: this.state.image_group && this.state.image_group.images[0] ? this.state.image_group.images[0].id : null,
      updated_at: this.props.property.updated_at || null,
      link_color: this.state.link_color,
      button_background_color: this.state.button_background_color,
      button_font_color: this.state.button_font_color,
      main_telephone: this.state.main_telephone,
      tollfree_telephone: this.state.tollfree_telephone,
      mobile_telephone: this.state.mobile_telephone,
      fax_telephone: this.state.fax_telephone,
      tdd_telephone: this.state.tdd_telephone,
      twilio_number: this.state.twilio_number,
      twilio_account_sid: this.state.twilio_account_sid,
      twilio_auth_token: this.state.twilio_auth_token,
      twilio_messaging_service_sid: this.state.twilio_messaging_service_sid,
      website_url: this.state.website_url,
      website_name: this.state.website_name,
      enable_messaging: this.state.enable_messaging,
      enable_messaging_terms: this.state.enable_messaging_terms,
      legal_business_name: this.state.legal_business_name,
      business_type: this.state.business_type,
      business_registration_id_type: this.state.business_registration_id_type,
      business_registration_number: this.state.business_registration_number,
      business_regions_of_operation: this.state.business_regions_of_operation,
      auth_rep_job_position: this.state.auth_rep_job_position,
      auth_rep_country_code: this.state.auth_rep_country_code,
      auth_rep_business_title: this.state.auth_rep_business_title,
      email: this.state.email,
      default_from_address: this.state.default_from_address,
      default_from_name: this.state.default_from_name,
      reservation_setting_attributes: {
        check_in_time: this.state.check_in_time,
        check_out_time: this.state.check_out_time,
        maximum_stay: this.state.maximum_stay,
        date_format: this.state.date_format,
        time_format: this.state.time_format,
        auto_assign: this.state.auto_assign,
        default_number_of_nights: this.state.default_number_of_nights,
        default_check_in_date: this.state.default_check_in_date,
        booking_window_days: this.state.booking_window_days
      },
      menu_items: this.state.menu_items,
      account_id: this.state.account_id,
      wihp_active: this.state.wihp_active,
      wihp_id: this.state.wihp_id,
      ru_active: this.state.ru_active,
      ru_contact_first_name: this.state.ru_contact_first_name || "",
      ru_contact_last_name: this.state.ru_contact_last_name || "",
      ru_contact_email: this.state.ru_contact_email || "",
      ru_contact_phone: this.state.ru_contact_phone || "",
      ru_contact_birthdate: this.state.ru_contact_birthdate || "",
      rooms_as_ru_properties: this.state.rooms_as_ru_properties,
      primary_contact_first_name: this.state.primary_contact_first_name || "",
      primary_contact_last_name: this.state.primary_contact_last_name || "",
      primary_contact_email: this.state.primary_contact_email || "",
      primary_contact_phone_number:
        this.state.primary_contact_phone_number || "",
      ad_words_conversion_id: this.state.ad_words_conversion_id || "",
      ad_words_conversion_label: this.state.ad_words_conversion_label || "",
      review_url: this.state.review_url || "",
      redirect_when: parseInt(this.state.review_when) * 2 / 10  || 0,
      pricing_table_enabled: this.state.pricing_table_enabled,
      pricing_table_size: this.state.pricing_table_size,
    };
  }
}
